import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { take } from 'rxjs/operators';
import { LoggerService } from 'src/app/services/logger/logger.service';
import { RestApiService } from 'src/app/services/rest-api/rest-api.service';
import { ToastNotificationService } from 'src/app/services/toast-notification/toast-notification.service';
import { isInputError } from 'src/app/shared/functions';
import { ToastNotificationComponent } from 'src/app/shared/toast-notification/toast-notification.component';

@Component({
  templateUrl: './additional-sign-redirect.component.html',
  styleUrls: ['./additional-sign-redirect.component.scss'],
  standalone: false
})
export class AdditionalSignRedirectComponent implements OnInit {
  public preloader = false;
  public success = false;
  public errored = false;
  public notFoundWithToken = false;

  public constructor(
    private route: ActivatedRoute,
    public toastService: ToastNotificationService,
    private loggerService: LoggerService,
    private restApiService: RestApiService,
  ) { }

  public ngOnInit(): void {
    this.preloader = true;
    this.route.paramMap.pipe(take(1)).subscribe((params: ParamMap) => {
      const token = params.get('token');
      if(token) {
        this.restApiService.signContractAddition(token).subscribe({
          error: this.handleConfirmError.bind(this),
          next: this.handleConfirmation.bind(this),
        });
      } else {
        this.preloader = false;
        this.errored = true;
      }
    })
  }

  private handleConfirmation(): void {
    this.preloader = false;
    this.toastService.addNotification({
      title: 'toastNotifications.headers.success',
      message: 'toastNotifications.messages.signConfirmed',
      type: 'success',
      component: ToastNotificationComponent
    });
    this.success = true;
  }

  private handleConfirmError(error: unknown): void {
    if(isInputError(error, 404, { excludeStatusCode: true })) {
      this.toastService.unknownApiError();
      this.errored = true;
      this.loggerService.error(typeof error === 'function' ? error() : error);
    } else {
      this.notFoundWithToken = true;
    }
    this.preloader = false;
  }
}
